/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CopyScriptRequest } from '../models/CopyScriptRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CopyScriptRestEndpointService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static copy({
        requestBody,
    }: {
        requestBody: CopyScriptRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/scripts/copy',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
